import { FileDTO } from "../domain/models/dto/FileDTO";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class FileServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static uploadFileOrReplaceThunk = createAsyncThunkFactory<FileDTO, FileDTO>(
        "FileServiceImpl.uploadFile",
        async (args) => {
            return this.post<FileDTO>(
                `/api/v1/file?&ownerType=${args.ownerType}&replaceCurrent=true`,
                args.data,
                "",
                { "Content-Type": args.data.type },
                false
            );
        }
    );
}
